export class ContactAddress {
    ContactAddressId: number;
    ContactId: number;
    AddressType: number;
    Address1: string;
    Address2: string;
    City: string;
    State: string;
    Zip: string;
    IsPrimary: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/crm/contact-address.model.ts